import { cn } from "@eisox/design-system";

import { m } from "~/paraglide/messages";

interface SummerWinterSchemeProps {
  summerStart: string;
  summerEnd: string;
  winterStart: string;
  winterEnd: string;
  className?: string;
}

export const SummerWinterScheme: React.FC<SummerWinterSchemeProps> = ({
  summerStart,
  summerEnd,
  winterStart,
  winterEnd,
  className,
}) => {
  const formatDate = (date: string) => (date ? date.replace("-", "/") : "--/--");

  return (
    <div
      className={cn(
        "flex h-[120px] w-fit justify-between rounded-[10px] border border-primary-darker-gray p-[20px]",
        className,
      )}
    >
      <p className={cn("font-normal flex flex-col items-center justify-end text-base italic")}>
        {formatDate(summerStart)}
      </p>
      <p className={cn("mx-5 font-semibold flex flex-col items-center justify-center text-base")}>{m.summer()}</p>
      <p className={cn("font-normal flex flex-col items-center justify-end text-base italic")}>
        {formatDate(summerEnd)}
      </p>
      <div className={cn("mx-[10px] h-full w-px border-l-2 border-dashed border-l-primary-dark-blue")} />
      <p className={cn("font-normal flex flex-col items-center justify-end text-base italic")}>
        {formatDate(winterStart)}
      </p>
      <p className={cn("mx-5 font-semibold flex flex-col items-center justify-center text-base")}>{m.winter()}</p>
      <p className={cn("font-normal flex flex-col items-center justify-end text-base italic")}>
        {formatDate(winterEnd)}
      </p>
    </div>
  );
};
